/*=========================================================================================
  File Name: actions.js
  Namespace: users
  Description: Vuex Store - User actions
==========================================================================================*/
import get from 'lodash.get'

import {
  getAccessToken,
  setAccessToken,
  removeAllTokens,
} from '@internetworkexpert/js-common'

import {
  userLogin,
  userStateStatus,
} from '../../services/uaa.service'

const actions = {
  async login({ commit }, payload) {
    const {
      username,
      password
    } = payload
    if (!username || !password) {
      throw Error('Email and password are required')
    }

    const response = await userLogin({
      username,
      password
    })
    const token = get(response.data, 'tokens.data.Bearer', '')

    commit('setUser', response.data)
    commit('setTokenToStore', {
      token: token
    })
    setAccessToken(token)

    return response
  },
  setToken({ commit }, payload) {
    commit('setTokenToStore', {
      token: payload
    })
  },
  // check if the store has user info, if not then get from Status endpoint
  async checkUserCompleteInfo({ state, commit }) {
    try {
      if (!state.currentUser.id) {
        const response = await userStateStatus()
        commit('setUser', response.data)
        return response
      }
      return true
    } catch (error) {
      throw error
    }
  },
  async logout({ commit }) {
    await removeAllTokens()
    commit('initializeUser')
  },
  tryAutoLogin: async (context) => {
    const token = getAccessToken()
    if (token) {
      context.commit('setTokenToStore', {
        token: token
      })
    } else {
      await context.dispatch('logout')
    }
  },
}

export default actions
